import { materialSymbols } from "../../../../../shared/constants/material-symbols";
import { IVoteOption } from "../../../../../shared/models/ballot-vote";

export interface IIecBallotVote {
  id: string;
  changedBy: string;
  remarks: string;
  submitted: string;
  committeeMember: string;
  iecBallotId: string;
  country: string;
  role: string;
  email: string;
  iecVoteOptionId: string;
  createDate: Date | null;
  lastUpdated: Date | null;
  votingRights: string;
  organisation: string;
  iecVoteOptionDisplayName: string;
  iecVoteOptionName: string;
  hasAuthDocument: boolean;
  hasCommented: boolean;

  header?: string;
  displayDetails?: boolean;
  rowIndex?: number;
  edit?: string;
  isBulkVote?: boolean;
  isEligible: boolean;
  hasVoted: boolean;
  showBallotHistory?: boolean;
  showBallotVoteComment?: boolean;
}



export interface IIecVote {
  ballotId: string;
  voteIds: string[];
  voteTypeId: IecVoteId;
  comment: string;

}

export interface IVoteRequest {
  ballotId: string
  voteId: string
  iecVoteOptionName: string
  comments: string
}

export interface IProxyVoteRequest {
  ballotId: string
  voteIds: string[]
  voteOption: string
  comments: string
  file: File | null
}

export enum IecVoteId {
  IN_FAVOUR_OF = "IN_FAVOUR_OF",
  AGAINST = "AGAINST",
  ABSTAIN = "ABSTAIN",
  NO_RESPONSE = "NO_RESPONSE",
}

export const iecVoteOption: { [key: string]: IVoteOption } = {
  "IN_FAVOUR_OF": {color: '#1A936F', icon: materialSymbols.thumbUp, text: 'In Favour Of'},
  "AGAINST": {color: '#CE1114', icon: materialSymbols.thumbDown, text: 'Against'},
  "ABSTAIN": {color: '#007AC9', icon: materialSymbols.cancel, text: 'Abstain'},
  "NO_RESPONSE": {color: '#FFB500', icon: materialSymbols.doNotDisturb, text: 'No Response'}
}
